import React, {Component} from 'react';
import * as R from 'ramda';

import FeedbackForm from 'js/components/feedback_form';
import FeedbackPanel from 'js/components/feedback_panel';

const feedbackOptions = [
    {id: 'not_brand_fit', text: 'Not a brand fit', icon: 'people'},
    {id: 'poor_quality', text: 'Poor quality', icon: 'thumbs-down'}
];

export default class DoNotDistributeFeedback extends Component {
    static defaultProps = {
        onCancel: R.identity,
        onSubmit: R.identity
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: null,
            feedbackText: ''
        };
    }

    onSelect = selectedOptions => {
        this.setState({selectedOptions});
    };

    onTextChange = e => {
        this.setState({feedbackText: e.target.value});
    };

    onSubmit = () => {
        const {onSubmit} = this.props;
        const {selectedOptions, feedbackText} = this.state;
        const feedback = R.trim(feedbackText);
        onSubmit({
            selectedOptions: R.pipe(
                R.filter(R.identity),
                R.keys
            )(selectedOptions),
            feedbackText: feedback === '' ? null : feedback
        });
    };

    render() {
        const {isTransmitting} = this.props;
        const {selectedOptions} = this.state;
        const hasSelectedOption = R.any(R.identity, R.values(selectedOptions));

        return (
            <FeedbackPanel
                heading="You have declined to distribute this piece of content"
                subheading="To improve future content, please select one or more reasons."
                onCancel={this.props.onCancel}
                onSubmit={this.onSubmit}
                submitDisabled={!hasSelectedOption || isTransmitting}
            >
                <FeedbackForm
                    options={feedbackOptions}
                    onSelect={this.onSelect}
                    onTextChange={this.onTextChange}
                />
            </FeedbackPanel>
        );
    }
}



// WEBPACK FOOTER //
// ./components/do_not_distribute_feedback/index.js